export default function Machines_C_1 (number = 1) {
  return {
    name: '高速分拣器',
    icon: '/static/img/machines/c1.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_C/Machines_C_1.js